import React, {PureComponent} from "react"
import {connect} from "react-redux"
import PropTypes from "prop-types"
import Button from "@irati/ui/src/Button"
import {injectIntl} from "@irati/utils/lang"
import id from "@irati/utils/id"
import {initiateSamlLogin} from "@irati/sso/helpers/webSSOPopup"
import authentication from "@irati/auth"
import AuthActions from "@irati/auth/store/actions/AuthActions"
import loginService from "@irati/auth/services/login"

import LoginBlock from "../../../components/LoginBlock"
import LoginPicAndHeader from "../../../components/LoginPicAndHeader"
import StyledLoginCard from "../styled/LoginCard"
import LoginFormWrapper from "../styled/LoginFormWrapper"

class LoginOnlySSO extends PureComponent {
  static propTypes = {
    idNamespace: PropTypes.string.isRequired,
    headerOne: PropTypes.string.isRequired,
    headerTwo: PropTypes.string.isRequired,
    singleSignOn: PropTypes.func.isRequired,
    onContinue: PropTypes.func.isRequired,
    text: PropTypes.string.isRequired
  }

  state = {
    submit: null
  }

  singleSignOnRedirect = () => {
    const {onContinue} = this.props
    return initiateSamlLogin(authentication.unAuthedBusiness()).then((response) => {
      const {access_token, user, tenant} = response
      const submit = loginService.ssoLogin(tenant, user, access_token).then(onContinue)
      this.setState({submit})
      return submit
    })
  }

  render() {
    const {idNamespace, headerOne, headerTwo, text} = this.props
    const {submit} = this.state

    const idSsoOnly = id("sso-only", idNamespace)
    return (
      <LoginBlock id={idSsoOnly}>
        <StyledLoginCard id={id("card", idSsoOnly)} large>
          <LoginFormWrapper id={id("form-wrapper", idSsoOnly)}>
            <LoginPicAndHeader name={idSsoOnly}>
              {headerOne}
              <br />
              {headerTwo}
            </LoginPicAndHeader>
            <Button full primary id={id("btn-sso", idSsoOnly)} load={submit} onClick={this.singleSignOnRedirect}>
              {text}
            </Button>
          </LoginFormWrapper>
        </StyledLoginCard>
      </LoginBlock>
    )
  }
}
export const LoginOnlySSOUnconnected = LoginOnlySSO

const mapDispatchToProps = (dispatch) => {
  return {
    singleSignOn: (authData) => dispatch(AuthActions.singleSignOn(authentication.userTenant(), authData))
  }
}

const mapStateToProps = ({mq}) => ({mq})

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(LoginOnlySSO)
)
